// src/i18n/index.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { version } from '../config/version';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // lng: 'en', // default language - English
    fallbackLng: 'en', // fallback to English
    
    // Supported languages
    supportedLngs: ['da', 'en', 'de', 'nb', 'sv'],
    // Browsers report regional codes ("de-DE", "da-DK"); match them to the
    // language we have and only ever load /locales/<language>/
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',

    // Language detection configuration
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'orbit_localization_i18nextLng',
      caches: ['localStorage'],
      excludeCacheFor: ['cimode'], // Don't cache in development mode
      // Norwegian devices may report "no" or "nn" rather than "nb"
      convertDetectedLanguage: (lng) => lng.replace(/^(no|nn)(?=-|$)/i, 'nb'),
    },
    
    // Namespaces - load all available namespaces by default
    ns: [
      'auth',
      'common',
      'departments',
      'equipment',
      'feedback',
      'files',
      'home',
      'infoscreens',
      'modules',
      'notifications',
      'procedures',
      'roles',
      'rooms',
      'inventory',
      'settings',
      'staff',
      'messages',
      'tasks',
      'contacts',
      'onboarding',
      'delegations',
      'tidsregistering',
      'errors',
    ],
    defaultNS: 'common',
    
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${version}`,
    },
    
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    
    react: {
      useSuspense: true, // Enable suspense mode for loading translations
    },
    
    // Debug mode - set to false in production
    debug: process.env.NODE_ENV === 'development',
  });

export default i18n;